import { initializeApp } from "firebase/app";
import { browserLocalPersistence, connectAuthEmulator, indexedDBLocalPersistence, initializeAuth } from "firebase/auth";

const mockMode = import.meta.env.VITE_MOCK_MODE !== "false";

// Mock mode always uses a "demo-" project, which only works against the local emulators,
// so local testing can never touch real data. Analytics is deliberately not loaded (no trackers).
export const firebaseApp = initializeApp(
  mockMode
    ? {
        apiKey: "demo-api-key",
        authDomain: "demo-student-organizer.firebaseapp.com",
        projectId: "demo-student-organizer",
      }
    : {
        apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
        authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
        projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
      },
);

// No pop-up helper here: Google's sign-in frame (and its third-party cookies) loads only when someone taps
// "Continue with Google" (see AuthProvider), which keeps the first page fast on phones.
// The browser never reads Firestore directly (everything goes through /api), so its SDK isn't loaded.
export const auth = initializeAuth(firebaseApp, { persistence: [indexedDBLocalPersistence, browserLocalPersistence] });

if (mockMode) {
  connectAuthEmulator(auth, "http://127.0.0.1:9099", { disableWarnings: true });
}
